
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.033 15.477c.002.445.182.87.5 1.182l4.866 4.85c.31.307.73.481 1.165.483h6.83c.44 0 .861-.173 1.173-.483l4.934-4.858c.318-.312.497-.738.499-1.182V8.69a1.666 1.666 0 00-.49-1.173l-4.926-4.984a1.663 1.663 0 00-1.181-.499H8.58c-.445.002-.87.182-1.182.5L2.516 7.523c-.307.31-.481.729-.483 1.165v6.788zM8.69 7.75a.768.768 0 01.59-.915.785.785 0 01.924.59l.782 3.652s0 .042.05 0V6.56c0-.424.35-.774.774-.774.424 0 .773.35.773.774v4.526c.015.01.035.01.05 0l.79-3.478a.768.768 0 01.99-.582.785.785 0 01.591.923l-.79 4.343 1.34-2.03a.782.782 0 011.322.832l-1.106 2.072a2.801 2.801 0 00-.333 1.314c0 1.739-.483 3.17-2.321 3.17h-1.78a2.336 2.336 0 01-1.665-.716l-2.728-3.61a.765.765 0 01-.05-1.09.785.785 0 011.098-.05l1.456 1.273c.022 0 .041-.02.041-.042L8.69 7.75z","fill":"currentColor"}})])
          )
        }
      }
    